module.exports = __webpack_public_path__ + "img/bag.5f040297.svg";